//
//
// functions
function goToSection__scroll(elRef) {
    var el = $(elRef);
    var goScroll = $(el).offset().top;
    setTimeout(function(){
        $('html, body').animate({
            scrollTop: goScroll - 30
        }, 800);
    }, 10);
}


//
// 
//  nav
if ($('.defaultNav').length) {
	var scroll_init = 0;
	$(window).on('scroll', function(event) {
		var scroll_body = $(this).scrollTop();
		var nav = $('nav');

		/*
			Aplica a classe que contem o estilo
			primário para o nav quando a pagina
			executar o evento scroll
		*/
		if (scroll_body > 99) {
			nav.addClass("defaultNav--scroll");
		} else {
			nav.removeClass("defaultNav--scroll");
		}

		/*
			Quando a página rolar 600px pra baixo o nav
			desaparece e recebe a classe "middle" para
			identificar o estado.
		*/
		if (scroll_body > 600) {
			nav.addClass("defaultNav--hide");
			nav.addClass("defaultNav--middle");
		} else {
			nav.removeClass("defaultNav--hide"); 
			nav.removeClass("defaultNav--middle");
		}

		/*
			verifica se o scroll da página foi
			pra cima, caso sim faz o menu aparecer.
		*/
		if (scroll_body < scroll_init) {
			nav.removeClass("defaultNav--hide");
		}
		
		// var referencia
		scroll_init = scroll_body;

		// innerpages adjust
        if ($('.defaultNav').hasClass('defaultNav--scroll')) {
            $('.innerPage').addClass('navScroll--isActive');
        } else {
            $('.innerPage').removeClass('navScroll--isActive');
        }

	});

	// open/close hamburguer menu
	$('.c-hamburguer').on('click', function() {
		$(this).toggleClass('is-active');
		$('.defaultNav__contentNav').toggleClass('is-active');
		$('.defaultNav__maskMenu').toggleClass('is-active');
		$('.u-maxRow').toggleClass('nav__is-active');
		$('body').toggleClass('u-overflowBlocked');
	});

	// close hamburguer menu
	$('.defaultNav__maskMenu').on('click', function() {
		$('.c-hamburguer').removeClass('is-active');
		$('.defaultNav__contentNav').removeClass('is-active');
		$('.defaultNav__maskMenu').removeClass('is-active');
		$('.u-maxRow').removeClass('nav__is-active');	
		$('body').removeClass('u-overflowBlocked');
	});

    $('.defaultNav .menu__secondSub').on('mouseenter', function(){
        $('.defaultNav a').removeClass('is-active');
        $(this).addClass('is-active');
    });

    $('.defaultNav .menu__secondSub').on('mouseleave', function(){
        $('.defaultNav .menu__secondSub').removeClass('is-active');
        console.log('teste');
    });
}

//
// 
//  float elements
$('.floatEl').enllax();


// 
// 
//  3d mouse hover elements
$('.js-tiltElement').tilt({
	maxTilt: 2,
	scale: 1,
	speed: 200,
    transition: false,
});


//
//
// pub swiper
var swiper__pubSection = new Swiper('.js-swiper_pub', {
    speed: 400,
    spaceBetween: 100,
    pagination: {
        el: '.swiper-pagination-pub',
        clickable: true,
	},
});


// 
// 
// instagram footer
/*var userFeed = new Instafeed({
	get: 'user',
	userId: '1471711225',
	accessToken: '1471711225.1677ed0.5e83233a24e64455b129136c34d32f5d',
	limit: 6,
	resolution: 'low_resolution',
	template: '<li class="js-tiltElement"><a href="{{link}}" target="_blank"><img src="{{image}}"/></a></li>',
});
userFeed.run();
$(window).on('load', function(event) {
	if ($("#instafeed li").length){
		var larguraThumbs = $('#instafeed li').width();
		$('#instafeed li').css('height', larguraThumbs);
	}
});*/

function somenteNumeros(num) {
    var er = /[^0-9.]/;
    er.lastIndex = 0;
    var campo = num;
    if (er.test(campo.value)) {
        campo.value = "";
    }
}

function allowAccess() {
    $('.l-avisoMaioridade__mask').remove();
    $('.l-avisoMaioridade__content').remove();
    $('.mainRow').removeClass('u-hideOpacity');
    $('body').css({
        'overflow-y': 'auto',
        'overflow-x': 'hidden'
    });
    
    if($('#modalHome').length){
        $('.openModalHome').trigger('click');
    }
}

function validaData(dia,mes,ano) {
    var aRet = true;
    if ((mes === 4 || mes === 6 || mes === 9 || mes === 11) && (dia > 30))
        aRet = false;
    else
    if ((ano % 4) !== 0 && mes === 2 && dia > 28)
       aRet = false;
    else
    if ((ano%4) === 0 && mes === 2 && dia > 29)
        aRet = false;
    else
    if (mes > 12 || mes < 1)
        aRet = false;
    else
    if (ano < 1900)
        aRet = false;
    else
    if (dia < 1)
        aRet = false;
    return aRet;
}

function validaIdade(d,m,a){
    var dtAtual = new Date();
    var y = dtAtual.getFullYear() - a;
    var mAtual= dtAtual.getMonth() + 1;
    var dAtual= dtAtual.getDate();
    console.log(y,a,mAtual,m,dAtual,d);
    if (y > 18) {
        return true;
    } else if(y === 18){
        if(m < mAtual){
            return true;
        }else if(m === mAtual){
            if(d <= dAtual){
                return true;
            }else{
                console.log('menor no dia');
                return false;
            }
        }else{
            console.log('menor no mes');
            return false;
        }
    } else {
        console.log('menor no ano');
        return false;
    }
}

// Modal +18
if ($('.l-avisoMaioridade__content').length) {

    $('.confirmMaioridade__yes').on('click', function() {
        if($('#input-accept').prop('checked')) {
            sessionStorage.setItem('maioridade', 'true');
            sessionStorage.getItem('maioridade');
            allowAccess();
        }
    });

    $('#ctAccess').on('click', function() {
        sessionStorage.setItem('maioridade', 'true');
        sessionStorage.getItem('maioridade');
        allowAccess();
    });

    $('#input-accept').on('change', function() {
        $('.input.unit').trigger('keyup');
    });

    $('.input.unit').on('keyup', function() {
        somenteNumeros(this);

        if (this.value.length === 2) {
            $(this).next('.input').focus();
        }

        var dia = $('#input-date-day').val();
        var mes = $('#input-date-month').val();
        var ano = $('#input-date-year').val();

        console.log(parseInt(dia),'/', parseInt(mes),'/',parseInt(ano),'/',ano.toString().length);
        if(parseInt(dia) > 0 && parseInt(mes) > 0 && parseInt(ano) > 0 && ano.toString().length === 4  ){
            if(validaData(parseInt(dia),parseInt(mes),parseInt(ano))){
                $('.input.unit').removeClass('error');
                if($('#input-accept').prop('checked')){
                    if(validaIdade(parseInt(dia),parseInt(mes),parseInt(ano))){
                        $('#ctAccess').removeClass('u-dnone');
                        $('#ctFacebook').addClass('u-dnone');
                    }else{
                        $('#ctAccess').addClass('u-dnone');
                        $('#ctFacebook').removeClass('u-dnone');
                    }
                }else{
                    $('#ctAccess').addClass('u-dnone');
                    $('#ctFacebook').addClass('u-dnone');
                }
            }else{
                //console.log('entrou');
                $('.input.unit').addClass('error');
                $('#ctAccess').addClass('u-dnone');
                $('#ctFacebook').addClass('u-dnone');
            }
        }else if(dia.toString().length > 0 && mes.toString().length > 0 && ano.toString().length === 4 ){
            $('.input.unit').addClass('error');
            $('#ctAccess').addClass('u-dnone');
            $('#ctFacebook').addClass('u-dnone');
        }else{
            $('.input.unit').removeClass('error');
            $('#ctAccess').addClass('u-dnone');
            $('#ctFacebook').addClass('u-dnone');
        }
    });

    //$(window).on('load', function() {
        if (sessionStorage.maioridade == "true") {
            allowAccess();
        } else {
            $('.l-avisoMaioridade__content').removeClass('u-dnone');
            $('.l-avisoMaioridade__mask').removeClass('u-dnone');
        }
    //});
}


//
//
// cervejas (home + page cervejas)
if ($('#cervejas').length){
    // cervejas - slider
    var swiper__gridCervejas = new Swiper('.swiper__gridCervejas__hero', {
        speed: 800,
        spaceBetween: 0,
        autoHeight: true,
        //effect: 'coverflow',
        //touchRatio: 0,
        nested: true,
        allowTouchMove: false,
        touchStartPreventDefault: false,
        passiveListeners: false,
    });

    $(window).resize(function(){
        swiper__gridCervejas.update();
    });

    $('.c-cardBeer').on('click', function() {
       var destiny = $(this).children('a').attr('href');
       location.href = destiny;
    });

    $('#cervejas .beerCategory li a').on('click', function () {
        var element = $('#cervejas .beerCategory li a');
        var beerCategory__Selected = $(this).attr('data-beerType');

        swiper__gridCervejas.slideTo(beerCategory__Selected);

        element.removeClass('is-active');
        $(this).addClass('is-active');

        goToSection__scroll('.beerCategory');
    });
}

//
//
// features card
if ($('.c-featureCard'.length)) {
    // Onde encontrar
    $(document).on('change','#ufOE',function(){
        var uf = $(this).val();
        $("#cidadesOE").html('<option>Carregando cidades...</option>');
        $.ajax({
            type: "POST",
            data: {uf: uf,oe: 'S'},
            url: "ajax-cidades.php",
            success: function (result) {
                $("#cidadesOE").html(result);
            }
        });
    });
    $(document).on('change','#ondeEncontrar__estado',function(){
        var uf = $(this).val();
        $("#ondeEncontrar__cidade").html('<option>Carregando cidades...</option>');
        $.ajax({
            type: "POST",
            data: {uf: uf,oe: 'S'},
            url: "ajax-cidades.php",
            success: function (result) {
                $("#ondeEncontrar__cidade").html(result);
            }
        });
    });
    $(document).on('change','#cidadesOE',function(){
        var cidade = $(this).val();
        $.ajax({
            type: "POST",
            data: {cidade: cidade},
            url: "ajax-onde-encontrar.php",
            success: function (result) {
                $("#page_ondeEncontrar--results").html(result);
                goToSection__scroll('#page_ondeEncontrar--results');
            }
        });
    });
    $(document).on('change','#ondeEncontrar__cidade',function(){
        $("#form_oe").submit();
    });

    // downloads
    $("#formDownloads").validate();
    $("#formDownloads_page").validate();
}

// link whats app - menu nav
var whatsAppLink = $('.js-linkWhatsApp');
if (is.iphone() || is.androidPhone() || is.windowsPhone() || is.blackberry()) {
    whatsAppLink.attr('href', whatsAppLink.attr('data-link-smartphone'));
} else {
    whatsAppLink.attr('href', whatsAppLink.attr('data-link-geral'));
}